import { formatTextFloat } from '../../../helpers/Text';
import ConstTooltip from '../../../common/mixTable/tooltip/Const';
import { typeChart } from './../../../common/mixTable/Const';
import { isEmpty } from 'lodash';

const compareRanking = value => {
  if (!isEmpty(value.last5RankValues)) {
    return value.last5RankValues[value.last5RankValues.length - 1];
  } else {
    return value.rankValue;
  }
};

const listColumn = [
  {
    key: 'rankValue',
    textAlign: 'center',
    isTopRate: true,
    width: '40px',
    isDisSort: true,
  },
  {
    key: 'ticker',
    typeTooltip: ConstTooltip.typeHover.hoverScore,
    textAlign: 'left',
    height: '100%',
    isShowFullTicker: true,
    keyOrgCode: 'organCode',
    keyOrganShortName: 'organShortName',
    keyNameAndExchange: 'nameAndExchange',
    keyCompare: 'rankValue',
    isString: true,
    keyPrevCompare: compareRanking,
  },
  {
    key: 'icbName',
    format: formatTextFloat,
    textAlign: 'left',
    isString: true,
  },
  {
    key: 'rankingHistory',
    typeChart: typeChart.areaChart,
    textAlign: 'left',
    width: '95px',
    thTooltip: 'table.strategy.rankingHistory',
  },
];

const listColumnRankingsIndicators = [
  { key: 'rankValue', textAlign: 'center', isTopRate: true, width: '40px' },
  {
    key: 'ticker',
    typeTooltip: ConstTooltip.typeHover.hoverScore,
    textAlign: 'left',
    height: '100%',
    isShowFullTicker: true,
    keyOrgCode: 'organCode',
    keyOrganShortName: 'organShortName',
    keyNameAndExchange: 'nameAndExchange',
    keyCompare: 'rankValue',
    keyPrevCompare: compareRanking,
  },
  { key: 'size', isSetColorText: true, textAlign: 'left' },
  { key: 'profit', isSetColorText: true, textAlign: 'left' },
  { key: 'cashflow', isSetColorText: true, textAlign: 'left' },
  { key: 'valuation', isSetColorText: true, textAlign: 'left' },
  {
    key: 'trading',
    isSetColorText: true,
    textAlign: 'left',
    thTooltip: 'table.strategy.trading',
  },
  {
    key: 'analysisCover',
    isSetColorText: true,
    textAlign: 'left',
    thTooltip: 'table.strategy.analysisCover',
  },
];
const dropList = [
  {
    icbCode: 'VN30',
    icbName: 'VN30',
  },
  { icbCode: 'HNX30', icbName: 'HNX30' },
];

const fetchDataSortKeys = [
  'ticker',
  'size',
  'profit',
  'cashflow',
  'valuation',
  'trading',
  'analysisCover',
  'rank',
];

export default {
  fetchDataSortKeys,
  listColumn,
  dropList,
  organCode: 'organCode',
  idPriceVolume: 'idPriceVolume',
  defaultOption: 'VolumeIncreaseAndPriceIncrease',
  maxRowData: 50,
  listColumnRankingsIndicators,
};
